<template>
  <div>
    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/banner_home.jpg`"
      ></BannerTopMobile>
    </div>

    <div class="container">

      <!--solo escritorios-->
      <div class="row d-none d-sm-none d-md-block">
        <div class="col d-flex justify-content-center mt-50">
          <div style="position: relative; left: 0; right: 0">
            <v-badge
              bordered
              left
              :content="`${cart.cart_products.length}`"
              color="accent"
              offset-x="10"
              offset-y="10"
              class="badge-bolsa"
            >
              <img
                class="cart-image-bolsa"
                src="@/assets/store/iconos/bolsa.svg"
              >
            </v-badge>
            <div class="div-title-cart font-backward">
              {{ is_auth ? `¡Hola! ${user.name}` : `Tu compra` }}
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-10 d-none d-sm-none d-md-block">
        <div class="col">
          <v-card color="light" elevation="0" class="p-3">
            <div v-if="cart.cart_products.length > 0">

              <!--esto se muestra en tablets y escritorios-->
              <div class="row">
                <div class="col">
                  <table class="table m-auto">
                    <thead>
                      <tr>
                        <!--<th style="width: 120px"></th>-->
                        <th style="width: 200px" class="color-blue font-general-r">PRODUCTO</th>
                        <th style="width: 100px" class="color-blue font-general-r">PRECIO</th>
                        <th style="width: 100px; text-align: center" class="color-blue font-general-r">CANTIDAD</th>
                        <th style="width: 100px; text-align: center" class="color-blue font-general-r">TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in cart.cart_products" :key="item.id">
                        <!--<td>
                          <img
                            :src="item.product.url_image_flask"
                            :alt="item.product.name"
                            class="img-product-cart"
                          />
                        </td>-->
                        <td>
                          <div class="mt-10">
                            <span class="h5 color-blue font-general-l">
                              {{ item.product.name.toUpperCase() }}
                            </span>
                            <p v-if="item.option_size" class="h5 color-blue font-general-l">
                              {{ item.option_size.toUpperCase() }}
                            </p>
                          </div>
                        </td>
                        <td>
                          <p class="h5 mt-10 color-blue font-general-l">
                            {{ currencyFormat(item.price) }}
                          </p>
                        </td>
                        <td>
                          <p class="h5 mt-10 color-blue font-general-l text-center">
                            {{ item.quantity }}
                          </p>
                        </td>
                        <td>
                          <h5 :class="`text-center mr-2 mt-10 color-blue font-general-l ${item.discount ? 'price-discount text-danger' : 'color-blue' }`">
                            {{
                              currencyFormat(item.subtotal)
                            }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="border-nv mb-10 mt-10"></div>

              <div class="row">
                <div class="col d-flex justify-content-end">
                  <div class="text-right mr-15">
                    <h4 class="color-blue font-general-r">SUBTOTAL</h4>
                  </div>
                  <div class="text-right">
                    <h4 class="color-blue font-general-r">
                      {{ currencyFormat(total_cart) }}
                    </h4>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col text-right">
                  <h5 class="color-blue font-general-r">Los impuestos y gastos de envío se calculan en la pantalla de pagos</h5>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="text-right mt-5 d-flex justify-content-end flex-wrap">
                    <v-btn
                      @click="() => $router.push('/procesar-pago')"
                      color="primary"
                      class="nv-btn nv-btn-hover nv-btn-large"
                      elevation="0"
                    >
                      PROCEDER AL PAGO
                    </v-btn>
                  </div>
                </div>
              </div>

            </div>
            <div v-else>
              <p class="text-center m-0 pb-5 h3 color-blue font-general-r">Tu carrito esta vacio.</p>
            </div>
          </v-card>
        </div>
      </div>

      <div class="row d-block d-sm-block d-md-none">
        <div class="col">
          <div v-if="cart.cart_products.length" class="px-3 mb-5">

            <div v-if="campaign_order && campaign_order.date == now" class="row py-2 mb-10">
              <div class="col text-center">
                <img class="frascos_campania" src="@/assets/store/diloconnieve/frascos_azules.svg" alt="">
              </div>
            </div>

            <!--esto se muestra en moviles-->
            <ItemCartMobile
              v-for="item in cart.cart_products" :key="item.id"
              :item="item"
              color_text="color-blue"
              color_badge="accent"
              :dark="false"
              badge="badge-blank"
              color_remove="accent"
            />

            <v-btn
              color="primary"
              class="mt-5 btn-subscription nv-btn-large"
              dark
              :loading="loading_btn_clean_cart"
              @click="cleanCart()"
              style="height: 30px !important;"
            >
              VACIAR CARRITO
            </v-btn>

            <div class="border-nv mb-5 mt-5"></div>

            <div v-if="select_discount" class="d-flex justify-space-between color-blue font-general-r">
              <p>Descuento: {{ select_discount.code }}</p>
              <p>{{ select_discount && select_discount.type != 'shipping_free' ? currencyFormat(amount_discount) : 'ENVÍO GRATIS' }}</p>
            </div>

            <div class="d-flex justify-space-between color-blue font-general-r">
              <p>{{ quantity_items_cart }} productos</p>
              <p>Total:</p>
              <p>{{ currencyFormat(total_cart) }}</p>
            </div>

            <DiscountCode
              :mobile_view="true"
              input_type="input-nv-discount-color-dark"
              @appliedDiscount="appliedDiscount"
            />

            <div class="text-right">
              <v-btn
                href="#unsabormas"
                color="secondary"
                class="nv-btn nv-btn-large mb-2"
                elevation="0"
              >
                SEGUIR COMPRANDO
              </v-btn> <br>
              <v-btn
                :to="{path: '/procesar-pago', query: {step: 'direccion-envio'}}"
                color="primary"
                class="nv-btn nv-btn-large"
                elevation="0"
              >
                FINALIZAR
              </v-btn>
            </div>
          </div>

          <p id="unsabormas" class="px-3 mt-10 color-blue font-general-r">¿QUÉ TAL UN SABOR MÁS?</p>
          <Flavors :show_buttons="false"></Flavors>

        </div>
      </div>

      <v-overlay :value="overlay">
        <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { currencyFormat } from '@/helpers'
import ItemCartMobile from '@/components/store/mobile/ItemCartMobile'
import Flavors from '@/components/store/Flavors'
import DiscountCode from '@/components/store/DiscountCode'
import moment from 'moment'

export default {
  components: {
    ItemCartMobile,
    Flavors,
    DiscountCode
  },
  data() {
    return {
      now: moment().format('YYYY-MM-DD'),
      overlay: false,
      url_banners_mobile: process.env.VUE_APP_URL_FILES,
      loading_btn_clean_cart: false
    }
  },
  computed: {
    ...mapState(['campaign_order', 'cart', 'is_auth', 'user', 'cart_total', 'select_discount', 'amount_discount']),
    ...mapGetters(['total_cart', 'quantity_items_cart'])
  },
  methods: {
    appliedDiscount(data) {
      if (!data.applied) {
        this.$swal('No cumples las condiciones para aplicar este descuento', '', 'warning')
      }
    },
    async cleanCart() {
      this.loading_btn_clean_cart = true
      await this.$store.dispatch('cleanCart')
      this.loading_btn_clean_cart = false
		},
    goPayment() {
      location.href = '/procesar-pago'
    },
    currencyFormat(price) {
			return currencyFormat(price)
		}
  },
  mounted() {
    this.overlay = true
    setTimeout(() => {
      this.overlay = false
    }, 1000)
  }
}
</script>

<style scoped>
  .table {
    border-collapse: collapse !important;
    border-spacing: 0px;
    table-layout: fixed;
  }
  th {
    border: none !important;
    font-size: 20px;
  }
  tr {
    border: none !important;
  }
  th, td {
    word-wrap: break-word;
  }
  >>>.table td, .table th {
    border-top: 0 !important
  }
</style>
